const isMac = window.navigator.platform.toLowerCase().startsWith('mac');
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
const isChromiumBased = !!(window as any).chrome;
/**
 * Due to:
 *
 * https://bugs.chromium.org/p/chromium/issues/detail?id=1292653
 *
 * Chromium based browsers have problematic behavior on macOS in regards to elements
 * that border on the browser chrome like the SideNav.
 * If you bring your mouse over the SideNav after putting focus in
 * another window then it will trigger both `mouseEnter` and
 * `mouseLeave` events even if you don't move the mouse away from the
 * SideNav. These events get triggered once and correct behavior only
 * happens after you give the browser focus.
 * This check should be used for mouse event handlers for elements at
 * the edge of the SideNav.
 *
 * The typical behavior for mac chromium based browsers is that mouse events
 * don't get triggered when the browser does not have focus so this approach
 * is consistent with that.
 */
export const shouldProcessMouseEvents = () => (isMac && isChromiumBased ? document.hasFocus() : true);
